<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const keyShortcuts = computed(() => [
  {
    key: 'K',
    description: t('CONVERSATION.EMPTY_STATE.CMD_BAR'),
  },
  {
    key: '/',
    description: t('CONVERSATION.EMPTY_STATE.KEYBOARD_SHORTCUTS'),
  },
]);
</script>

<template>
  <div class="flex gap-4 mt-8 select-none">
    <div
      v-for="keyShortcut in keyShortcuts"
      :key="keyShortcut.key"
      class="flex flex-col items-center justify-center px-6 py-4 rounded-xl border border-n-slate-3 dark:border-n-slate-4/10 bg-white dark:bg-n-alpha-2 shadow-xs min-w-[160px] max-w-[180px] transition-all duration-200 hover:shadow-sm hover:scale-[1.02] hover:border-n-slate-4"
    >
      <div class="flex gap-1.5 items-center mb-2">
        <kbd
          class="px-2 py-1 text-xs font-semibold text-n-slate-12 bg-n-alpha-3 border border-n-slate-4 rounded-md shadow-xs"
        >
          {{ $t('CONVERSATION.EMPTY_STATE.CMD') }}
        </kbd>
        <span class="text-xs text-n-slate-10 font-bold">+</span>
        <kbd
          class="px-2 py-1 text-xs font-semibold text-n-slate-12 bg-n-alpha-3 border border-n-slate-4 rounded-md shadow-xs"
        >
          {{ keyShortcut.key }}
        </kbd>
      </div>
      <span class="text-xs font-semibold text-center text-n-slate-11">
        {{ keyShortcut.description }}
      </span>
    </div>
  </div>
</template>
